module.exports = __webpack_public_path__ + "media/explode.de355ad7.webm";